import { Injectable } from '@angular/core';
import { fromSessionStorage } from '../store.service';
import { CmsState } from './cms.types';

@Injectable({providedIn: 'root'})
export class CmsStore {

  readonly settingKey = 'cms';
  readonly currentCmsData = fromSessionStorage<CmsState>(this.settingKey);

  initCMSData(data: CmsState): void {
    this.currentCmsData.set(data);
  }

  updateCMSPartial(state: Partial<CmsState>): void {
    const current = this.currentCmsData();
    this.currentCmsData.set({...current, ...state});
  }

  public clearData(): void {
    this.currentCmsData.set(null);
  }

}
